function LazyLoadVideos($) {

  /**
	* initialization method
	*/
  const init = () => {
    
    const $window = $(window);
    const $lazyVideos = $(".lazy-load");
    let counter = 0;
    
    if($lazyVideos.length > 0) {

      // add 'not-loaded' class to each video
      $lazyVideos.each(function() {
        $(this).addClass('.not-loaded');
      });

      /***
       * Function that handles video loading
       * 
       * @param  videos  jQuery object
       **/
      const handleLoad = function(videos){
        videos.each(function() {
          if($(this).hasClass('.not-loaded')) {
            if( $(this).offset().top <= $window.scrollTop() + $window.height() / 2) {
              $(this)[0].src = $(this)[0].dataset.src;
              $(this).removeClass('.not-loaded');
            }
          }
        });
      }

      handleLoad($lazyVideos);

      // on scroll call handleLoad function
      $window.on('scroll', () => {
        if(counter > 20) {
          handleLoad($lazyVideos);
          counter = 0;
        }
        counter++;
      });
      
    }
  }
  return {
    init
  }
}

export default LazyLoadVideos;